<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      max-height="500"
      border="none"
      :loading="loading"
      :data="invoiceListData"
      :auto-resize="true"
      align="center"
      :footer-method="footerMethod"
      @filter-change="filterTypeMethod"
      ref="xTable"
    >
      <vxe-table-column type="seq" title="序号" width="100">
        <template slot-scope="{ row, $rowIndex }">
          <span>{{ $rowIndex + 1 }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="paymentsNum" title="收付款编号">
        <template slot-scope="{ row }">
          <a class-name="link-text" @click="cellClick(row)">{{
            row.paymentsNum
          }}</a>
        </template>
      </vxe-table-column>
      <vxe-table-column field="ordersNum" title="子订单号"></vxe-table-column>
      <vxe-table-column field="addTime" title="日期">
        <template slot-scope="{ row }">
          <span>{{ row.addTime | timeFormatDate }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="note" title="摘要"></vxe-table-column>
      <vxe-table-column field="balanceAmount" title="金额"></vxe-table-column>
      <vxe-table-column
        field="ownName"
        title="所属方"
        :filters="filterOwnName"
      ></vxe-table-column>
      <vxe-table-column
        field="paymentsName"
        title="付款方名称"
      ></vxe-table-column>
      <vxe-table-column field="recName" title="收款方名称"></vxe-table-column>
      <vxe-table-column field="tradeState" title="付款状态">
        <template slot-scope="{ row }">
          <span>{{ row.tradeState | payStatusMap }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page.sync="page.currentPage"
      :page-size.sync="page.pageSize"
      :total="page.totalResult"
      @page-change="handlePageChange"
    ></vxe-pager>
    <vxe-modal
      v-model="isShowPaymentDetail"
      width="1300"
      height="660"
      resize
      remember
      title="收付款详情"
    >
      <payment-detail
        :chainId="id"
        :cate="paymentCate"
        :isShow="isShowPaymentDetail"
        ref="paymentDetail"
        @close="isShowPaymentDetail = false"
        @init="init"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal
      v-model="isShowCollectionDetail"
      width="1300"
      height="660"
      resize
      remember
      title="收付款详情"
    >
      <collection-detail
        :cate="'Collection'"
        :isShow="isShowCollectionDetail"
        ref="collectionDetail"
        @close="isShowCollectionDetail = false"
        @init="init"
      ></collection-detail>
    </vxe-modal>
    <vxe-modal
      v-model="isShowCarryOverDetail"
      title="结转详情"
      width="1300"
      height="460"
      resize
      remember
    >
      <carry-over-detail
        :isShow="isShowCarryOverDetail"
        ref="carryOverDetail"
        @close="isShowCarryOverDetail = false"
      ></carry-over-detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import PaymentDetail from "@/views/payment/PaymentDetail.vue";
import CollectionDetail from "@/views/payment/CollectionDetail.vue";
import CarryOverDetail from "@/views/payment/CarryOverDetail.vue";
import { getFilterObj } from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";
import openProcedureDetailTwo from "@/mixin/viewOrderDetail";

// 销项发票
export default {
  props: {
    id: Number,
    pageTab: String,
  },
  components: {
    PaymentDetail,
    CollectionDetail,
    CarryOverDetail,
  },
  mixins: [getAuthOrization],
  data() {
    return {
      loading: false,
      invoiceListData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      countRtnVo: {},
      isShowPaymentDetail: false,
      isShowCollectionDetail: false,
      paymentCate: null,
      collectionCate: null,
      filterOwnName: [],
      ownName: null,
      isShowCarryOverDetail: false,
    };
  },
  watch: {
    // id(nv, ov) {
    //   if (nv !== ov && nv !== undefined) {
    //     this.getPayListData();
    //   }
    // },
    pageTab() {
      this.pageTab === "tab8" ? this.getPayListData() : "";
    },
  },
  // activated() {
  //   // this.getInvoiceListData();
  //   this.$bus.$on("allOrderDetailRenovate", (data) => {
  //     data === true ? this.getPayListData() : "";
  //   });
  // },
  methods: {
    init() {
      this.page.currentPage = 1;
      this.getPayListData();
    },
    filterTypeMethod({ column, property, values, datas, filters, $event }) {
      this.page.currentPage = 1;
      if (values.length > 0) {
        if (property == "ownName") {
          this.ownName = values;
        }
      } else {
        this.ownName = null;
      }
      this.getPayListDataFilter();
    },
    async getPayListDataFilter() {
      this.filterOwnName = [];
      this.loading = true;
      let res = await $api.payments.request("queryPaymentsList", {
        chainId: this.id,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
        ownName: this.ownName,
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.countRtnVo = res.data.countRtnVo;
        let invoiceListData = res.data.rows;
        this.invoiceListData = invoiceListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getPayListData() {
      this.filterOwnName = [];
      this.loading = true;
      let res = await $api.payments.request("queryPaymentsList", {
        chainId: this.id,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.countRtnVo = res.data.countRtnVo;
        let invoiceListData = res.data.rows;
        const xTable = this.$refs.xTable;
        const ownNameColumn = xTable.getColumnByField("ownName");
        invoiceListData.map((i) => {
          getFilterObj(this.filterOwnName, i.ownName);
        });
        xTable.setFilter(ownNameColumn, this.filterOwnName);
        xTable.updateData();
        this.invoiceListData = invoiceListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      // 分页
      this.page.currentPage = currentPage;
      this.page.pageSize = pageSize;
      this.getPayListDataFilter();
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "单页合计";
          }
          if (["balanceAmount"].includes(column.property)) {
            return this.$utils.sum(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "全部合计";
          }
          if (["balanceAmount"].includes(column.property)) {
            return this.countRtnVo.totalBalanceAmount;
          }

          return null;
        }),
      ];
    },
    viewCarryOverDetail(id) {
      this.isShowCarryOverDetail = true;
      this.$refs.carryOverDetail.initDetail(id);
    },
    cellClick(e) {
      // let field = e.column.property;
      if (e.sourceType === 6) {
        // 打开结转流程
        this.viewCarryOverDetail(e.id);
      } else {
        if (e.paymentType !== 1 && e.paymentsState == 2) {
          if (!this.isHavePermission('PaymentsSeller')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
          this.isShowPaymentDetail = true;
          this.paymentCate = e.sellerLv2Name ? "SellerPayment" : "Payment";
          this.$refs.paymentDetail.init(e.id, this.paymentCate);
        } else {
          if (!this.isHavePermission('PaymentsBuyer')){
            this.$Message["info"]({
              background: true,
              content: "对不起，您没有该权限！"
            });
            return ;
          }
          this.isShowCollectionDetail = true;
          this.collectionCate = "Collection";
          this.$refs.collectionDetail.init(e.id);
        }
      }
    },
  },
};
</script>

<style>
</style>